export default ({
  pageState: { editorAdders, editorBlocks, editorBlocksOrder },
  data: { blockIds, blocks, editor, updatedAt }
}) => {
  return {
    editorAdders: [...editorAdders, ...blockIds.map(() => false)],
    editorBlocks: {
      ...editorBlocks,
      ...Object.keys(blocks).reduce((obj, blockId) => {
        obj[blockId] = { ...blocks[blockId], editor, updatedAt };
        return obj;
      }, {})
    },
    editorBlocksOrder: [...editorBlocksOrder, ...blockIds],
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDraft: true
  };
};
